import { Component, output } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-listing-details-cta-middleton',
  styleUrl: './middleton.css',
  templateUrl: './middleton.html',
})
export class ListingDetailsCtaMiddleton {
  public readonly lppClicked = output();
}
